import React, { useState } from "react";
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: "http://www.marroccoart.com/payment-success",  // Change to your success page URL
      },
    });

    if (error) {
      // Show error to the customer
      setErrorMessage(error.message);
      setIsLoading(false);
    } else {
      setErrorMessage(null);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-4">
      <PaymentElement className="mb-4" />
      
      {/* Error Message */}
      {errorMessage && <div className="text-red-500 mb-4">{errorMessage}</div>}
      
      <button
        type="submit"
        disabled={!stripe || isLoading}
        className={`w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition ${isLoading ? 'opacity-50' : ''}`}
      >
        {isLoading ? "Processing..." : "Pay Now"}
      </button>
    </form>
  );
};

export default CheckoutForm;